<template>
    <div>
    <a-row>
      <a-col :span="4">
      </a-col>
      <a-col :span="16">
          <div class="title">
                经济学院专业教师科研考核表（2023版）
          </div>
      </a-col>
      <a-col :span="4">
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="8">
      </a-col>
      <a-col :span="8">
          <div class="schoolYear">
                {{year}}
          </div>
      </a-col>
      <a-col :span="8">
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="6">
      </a-col>
      <a-col :span="4">
          <div class="schoolYear">
                {{orgName}}(所、中心） 
          </div>
      </a-col>
      <a-col :span="4">
          <div class="schoolYear">
                教师姓名：{{teacherName}}
          </div>
      </a-col>
      <a-col :span="4">
          <div class="schoolYear">
            专技职务：{{technicalTitleName}}
          </div>
      </a-col>
      <a-col :span="6">
      </a-col>
    </a-row>

<a-row>
    <a-col :span="23">
    </a-col>
    <a-col :span="1">
        <div style="margin:0px 10px 10px 0px">
            <a-button type="primary" v-if="type =='add'" @click="showModal">新增</a-button> 
        </div>
    </a-col>
</a-row>

    <a-row>
      <!-- <a-col :span="2">
      </a-col> -->
      <a-col :span="24">
            <a-table :columns="columns" :data-source="data" :pagination='false'  size='small' bordered>
                <span slot="operation" slot-scope="text, record">
                    <div v-if="record.mainTitleName!='合计'">
                        <a class="operate" @click="showModal(record)">编辑</a>
                        <a-divider type="vertical" v-if="type =='add'"/>
                        <a-popconfirm
                            v-if="type =='add'"
                            title="确定删除？"
                            ok-text="确定"
                            cancel-text="取消"
                            @confirm="remove(record)"
                            
                        >
                            <a class="operate">删除</a>
                        </a-popconfirm> 
                    </div>
                </span>
            </a-table>
        <a-row >
            <!-- <a-col :span="6" class="qr">
                *人事绩效系统（科研）总分：<a-input-number class="input" v-model="hrScore" disabled/>
            </a-col>
            <a-col :span="6" class="qr">
                科研核定总分：<a-input-number class="input" v-model="totalScore" :disabled="type!='approve'"/>
            </a-col> -->
            <a-col :span="24" class="qr" v-if="type=='approve' || this.type == 'look' || this.type == 'confirm'">
                审核意见：<a-textarea style="width:90rem" v-model="approveInfo.approvalComments" allowClear :disabled='type!="approve"'/>
            </a-col>
        </a-row>
        <a-row >
            <a-col :span="6" class="qr">
                被考核人签名：{{confirmer}}
            </a-col>
            <a-col :span="6" class="qr">
                {{confirmDate}}
            </a-col>
            <a-col :span="12">
            </a-col>
        </a-row>
        <a-row >
            <a-col :span="24" class="bz">
                备注：本表*人事绩效系统（科研）得分由教师本人填写,*学院核定分值由学院填写。   
            </a-col>
        </a-row>
      </a-col>
      <!-- <a-col :span="2">
      </a-col> -->
    </a-row>
    <div class="btn-box">
        <a-button type="primary"   @click="commit" v-if="type =='add'">提交</a-button>
        <a-button type="primary" @click="confirm"  v-if="type =='confirm'">确认</a-button>
        <a-popconfirm
                title="请确认学院科研核定分是否正确！"
                ok-text="确定"
                v-if="type =='approve'"
                cancel-text="取消"
                @confirm="approve('approved')"
                
            >
        <a-button type="primary">通过</a-button>
        </a-popconfirm>
        <a-button type="primary" @click="approve('reject')"  v-if="type =='approve'">驳回</a-button>
        <a-button @click="$router.go(-1)">取消</a-button>
    </div>
    <a-modal
      title="详细信息"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      width='50rem'
      @cancel="handleCancel"
    >
      <div class="info-main">
        <div class="input-box">
            <p>科研大类：</p>
             <a-select class="input" v-model="info.mainTitleCode" @change="kyxl" :disabled="type !='add'">
                <a-select-option v-for="(item,index) in kykhdlArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
       <div class="input-box">
            <p>科研小类：</p>
             <a-select class="input" v-model="info.subTitleCode" :disabled="type !='add'">
                <a-select-option v-for="(item,index) in kyxlArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>名称：</p>
             <a-input class="input" v-model="info.name" allowClear :disabled="type !='add'"/>
        </div>
        <div class="input-box">
            <p>期刊/出版社：</p>
            <a-select class="input" v-model="info.journal" allowClear :disabled="type !='add'">
                <a-select-option  value="期刊">期刊</a-select-option>
                <a-select-option  value="出版社">出版社</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>发表年月：</p>
            <a-month-picker v-model="info.publishDate" @change="onChange" class="input" :disabled="type !='add'"/>
        </div>
        <div class="input-box">
            <p>第一/通讯/其他作者：</p>
            <a-select class="input" v-model="info.author" allowClear :disabled="type !='add'">
                <a-select-option  value="第一作者">第一作者</a-select-option>
                <a-select-option  value="通讯作者">通讯作者</a-select-option>
                <a-select-option  value="其他作者">其他作者</a-select-option>
            </a-select>
        </div>
        <!-- SCI论文
            SSCI论文
            A&HCI检索论文
            ESI高被引论文
            CSSCI（核心版）
            CSSCI（扩展版）
            其他 -->
        <!-- <div class="input-box">
            <p>收录类别：</p>
            <a-select class="input" v-model="info.categoryInclusion" allowClear :disabled="type !='add'">
                <a-select-option  value="SCI论文">SCI论文</a-select-option>
                <a-select-option  value="SSCI论文">SSCI论文</a-select-option>
                <a-select-option  value="A&HCI检索论文">A&HCI检索论文</a-select-option>
                <a-select-option  value="ESI高被引论文">ESI高被引论文</a-select-option>
                <a-select-option  value="CSSCI（核心版）">CSSCI（核心版）</a-select-option>
                <a-select-option  value="CSSCI（扩展版）">CSSCI（扩展版）</a-select-option>
                <a-select-option  value="其他">其他</a-select-option>
            </a-select>
        </div> -->
        <div class="input-box">
            <p>中科院/JCR分区：</p>
            <a-select class="input" v-model="info.jcr" allowClear :disabled="type !='add'">
                <a-select-option  value="中科院分区">中科院分区</a-select-option>
                <a-select-option  value="JCR分区">JCR分区</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>项目类别：</p>
            <a-select class="input" v-model="info.itemType" allowClear :disabled="type !='add'">
                <a-select-option  value="国家">国家</a-select-option>
                <a-select-option  value="省部级">省部级</a-select-option>
                <a-select-option  value="其他纵向">其他纵向</a-select-option>
                <a-select-option  value="横向">横向</a-select-option>
            </a-select>
        </div>
        <!-- <div class="input-box">
            <p>立项年月：</p>
            <a-month-picker v-model="info." class="input" />
        </div> -->
        <!-- <div class="input-box">
            <p>2021年项目入账经费（万元）：</p>
             <a-input class="input" v-model="info.itemRecorded" allowClear/>
        </div>
        <div class="input-box">
            <p>是/否在上大机构知识库：</p>
            <a-select class="input" v-model="info.inShuOrg" allowClear>
                <a-select-option  :value='true'>是</a-select-option>
                <a-select-option  :value='false'>否</a-select-option>
            </a-select>
        </div> -->
        <div class="input-box">
            <p>*人事绩效系统中得分：</p>
            <a-input-number class="input" v-model="info.hrScore" allowClear :disabled="type !='add'"/>
        </div>
        <div class="input-box" v-if="type == 'approve'">
            <p>*学院核定分值：</p>
            <a-input-number class="input" v-model="info.approveScore" allowClear/>
        </div>
        <div class="input-box">
            <p>备注：</p>
            <a-textarea class="input" v-model="info.remark" allowClear :disabled="type !='add'"/>
        </div>
      </div>
    </a-modal>
    
  </div>
  
</template>
<script>
import { info,add,del,commit,edit,approve,confirm,approveEdit } from '@/baseAPI/research/assess'
import { getDicts } from '@/baseAPI/dictionary'

export default {
  data() {
    return {
        data:[],
        columns:[
        {
            title: '',
            dataIndex: 'mainTitleName',
            width:100,
            align:'center',
            customRender: (text, row, index) => {
                const obj = {
                    children: text,
                    attrs: {},
                };
                this.rowSpan.forEach(e => {
                    if(e.start == index){
                        obj.attrs.rowSpan = e.end - e.start + 1;
                    }
                    if(index > e.start && index <= e.end){
                        obj.attrs.rowSpan = 0
                    }
                });
                if(row.mainTitleName == '合计'){
                    obj.attrs.colSpan = 9
                }
                return obj;
            }
        },
        {
            title: '',
            dataIndex: 'subTitleName',
            width:100,
            customRender: (text, row, index) => {
                const obj = {
                    children: text,
                    attrs: {},
                };
                this.subRowSpan.forEach(e => {
                    if(e.start == index){
                        obj.attrs.rowSpan = e.end - e.start + 1;
                    }
                    if(index > e.start && index <= e.end){
                        obj.attrs.rowSpan = 0
                    }
                });
                if(row.mainTitleName == '合计'){
                    obj.attrs.colSpan = 0
                }
                return obj;
            }
        },
        {
            title: '名称',
            dataIndex: 'name',
            width:200,
            customRender: (text, row, index) => {
                const obj = {
                    children: text,
                    attrs: {},
                };
                if(row.mainTitleName == '合计'){
                    obj.attrs.colSpan = 0
                }
                return obj;
            }
        },
        {
            title: '期刊/出版社',
            dataIndex: 'journal',
            width:100,
            customRender: (text, row, index) => {
                const obj = {
                    children: text,
                    attrs: {},
                };
                if(row.mainTitleName == '合计'){
                    obj.attrs.colSpan = 0
                }
                return obj;
            }
        },
        {
            title: '发表年月',
            dataIndex: 'publishDate',
            width:100,
            customRender: (text, row, index) => {
                const obj = {
                    children: text,
                    attrs: {},
                };
                if(row.mainTitleName == '合计'){
                    obj.attrs.colSpan = 0
                }
                return obj;
            }
        },
        {
            title: '第一/通讯/其他作者',
            dataIndex: 'author',
            width:100,
            customRender: (text, row, index) => {
                const obj = {
                    children: text,
                    attrs: {},
                };
                if(row.mainTitleName == '合计'){
                    obj.attrs.colSpan = 0
                }
                return obj;
            }
        },
        {
            title: '收录类别（SSCI/SCI/CSSCI)',
            dataIndex: 'categoryInclusion',
            width:100,
            customRender: (text, row, index) => {
                const obj = {
                    children: text,
                    attrs: {},
                };
                if(row.mainTitleName == '合计'){
                    obj.attrs.colSpan = 0
                }
                return obj;
            }
        },
        {
            title: '中科院/JCR分区',
            dataIndex: 'jcr',
            width:100,
            customRender: (text, row, index) => {
                const obj = {
                    children: text,
                    attrs: {},
                };
                if(row.mainTitleName == '合计'){
                    obj.attrs.colSpan = 0
                }
                return obj;
            }
        },
        {
            title: '项目类别（国家/省部级/其他纵向/横向）；立项年月',
            dataIndex: 'itemType',
            width:100,
            customRender: (text, row, index) => {
                const obj = {
                    children: text,
                    attrs: {},
                };
                if(row.mainTitleName == '合计'){
                    obj.attrs.colSpan = 0
                }
                return obj;
            }
        },
        // {
        //     title: '项目入账经费（万元）',
        //     dataIndex: 'itemRecorded',
        //     width:100
        // },
        // {
        //     title: '是/否在上大机构知识库',
        //     dataIndex: 'inShuOrg',
        //     width:100,
        //     customRender: (text, row, index) => {
        //         if(text){
        //             return '是'
        //         }else{
        //             return '否'
        //         }
        //     }
        // },
        {
            title: '*人事绩效系统中得分',
            dataIndex: 'hrScore',
            width:100
        },
        {
            title: '*学院核定分值',
            dataIndex: 'approveScore',
            width:100
        },
        {
            title: '备注',
            dataIndex: 'remark',
            width:100
        },
        {
            title: '',
            dataIndex: '',
            scopedSlots: { customRender: 'operation' },
            width:100
        },
    ],
        result:[],
        orgName:'',
        teacherName:'',
        teacherId:'',
        technicalTitleName:'',
        visible: false,
        confirmLoading: false,
        kykhdlArr:[],
        lglkyxlArr:[],
        rwsklkyxlArr:[],
        kyhyxlArr:[],
        qtArr:[],
        kyxlArr:[],
        info:{
            assessId: null,
            mainTitleCode: null,
            subTitleCode: null,
            name: null,
            journal: null,
            publishDate: null,
            author: null,
            categoryInclusion: null,
            itemType: null,
            itemRecorded: null,
            inShuOrg: true,
            hrScore: null,
            remark: null,
            approvalStatus:null
        },
        approveInfo:{
            id:'',
            approvalStatus:'',
            approvalComments:'',
            totalScore:''
        },
        year:"",
        type:'',
        confirmer:'',
        confirmDate:'',
        hrScore:'',
        assessId:'',
        totalScore:'',
        rowSpan:[],
        subRowSpan:[],
        approvalStatus:null
    };
  },
  mounted(){
        this.teacherId = this.$route.query.teacherId;
        this.assessId = this.$route.query.assessId;
        this.type = this.$route.query.type;
        this.approvalStatus = this.$route.query.approvalStatus;
        getDicts({dataCode:'KYCG-KYKHDL',status:true}).then(res=>{
            this.kykhdlArr=res.data.dicts;
        })
        getDicts({dataCode:'KYCG-LGLKY',status:true}).then(res=>{
            this.lglkyxlArr=res.data.dicts;
        })
        getDicts({dataCode:'KYCG-RWSKLKY',status:true}).then(res=>{
            this.rwsklkyxlArr=res.data.dicts;
        })
        getDicts({dataCode:'KYCG-KYHY',status:true}).then(res=>{
            this.kyhyxlArr=res.data.dicts;
        })
        getDicts({dataCode:'KYCG-OTH',status:true}).then(res=>{
            this.qtArr=res.data.dicts;
        })

        if(this.type == 'add'){
            this.columns.splice(10,1)
        }

        if(this.type == 'confirm' || this.type == 'look'){
            this.columns.splice(12,1)
        }

        setTimeout(()=>{
            this.fetch()
            if((this.approvalStatus == 'init' || this.approvalStatus == 'saved' || this.approvalStatus == 'commit') && this.type != 'approve'){
                this.columns.splice(10,1)
            }
        },100)
  },
  methods:{
    approve(approvalStatus){
        this.approveInfo.id=this.assessId
        this.approveInfo.approvalStatus = approvalStatus;
        this.approveInfo.totalScore = this.totalScore
        approve(this.approveInfo).then(res=>{
            if(res.data.success){
                this.$notification['success']({
                    message: '成功',
                    description:'审核成功',
                });
                this.$router.go(-1)
            }else{
                this.$notification['error']({
                    message: '失败',
                    description:res.data.errorMessage,
                });
            }
        })
    },
    commit(){
        commit(this.assessId).then(res=>{
            if(res.data.success){
                this.$notification['success']({
                    message: '成功',
                    description:'提交成功',
                });
                this.$router.go(-1)
            }else{
                this.$notification['error']({
                    message: '失败',
                    description:res.data.errorMessage,
                });
            }
        })
    },
    remove(record){
        del(record.id).then(res=>{
            if(res.data.success){
                this.$notification['success']({
                    message: '成功',
                    description:'删除成功',
                });
                this.fetch()
            }else{
                this.$notification['error']({
                    message: '失败',
                    description:res.data.errorMessage,
                });
            }
            this.confirmLoading = false;
        })
    },
    onChange(date, dateString) {
        this.info.publishDate = dateString
    },
    add(){
        this.info.assessId=this.assessId;
        add(this.info).then(res=>{
            if(res.data.success){
                this.$notification['success']({
                    message: '成功',
                    description:'新增成功',
                });
                this.fetch()
            }else{
                this.$notification['error']({
                    message: '失败',
                    description:res.data.errorMessage,
                });
            }
            this.confirmLoading = false;
        })
    },
    edit(){
        if(this.type == 'approve'){
            approveEdit(this.info).then(res=>{
                if(res.data.success){
                    this.$notification['success']({
                        message: '成功',
                        description:'学院核定分值编辑成功',
                    });
                    this.fetch()
                }else{
                    this.$notification['error']({
                        message: '失败',
                        description:res.data.errorMessage,
                    });
                }
                this.confirmLoading = false;
            })
        }else{
            edit(this.info).then(res=>{
                if(res.data.success){
                    this.$notification['success']({
                        message: '成功',
                        description:'编辑成功',
                    });
                    this.fetch()
                }else{
                    this.$notification['error']({
                        message: '失败',
                        description:res.data.errorMessage,
                    });
                }
                this.confirmLoading = false;
            })
        }
    },
    kyxl(val){
        if(val == 'KYCG-LGLKY'){
            this.kyxlArr = this.lglkyxlArr;
        }else if(val == 'KYCG-RWSKLKY'){
            this.kyxlArr = this.rwsklkyxlArr;
        }else if(val == 'KYCG-KYHY'){
            this.kyxlArr = this.kyhyxlArr
        }else if(val == 'KYCG-OTH'){
            this.kyxlArr = this.qtArr
        }
    },
    showModal(record) {
        if(record.assessId != null){
            this.info=record;
        }
        this.visible = true;
        this.kyxl(this.info.mainTitleCode)
    },
    handleOk(e) {
        this.confirmLoading = true;
        if(this.info.id != '' && this.info.id != null){
            if(this.type == 'add'){
                if(this.info.hrScore == null){
                    this.$notification['warning']({
                            message: '人事绩效系统中得分不能为空！'
                    });
                    this.confirmLoading = false;
                    return;
                }
            }else{
                if(this.info.approveScore == null){
                    this.$notification['warning']({
                            message: '学院核定分值不能为空！'
                    });
                    this.confirmLoading = false;
                    return;
                }
            }
            this.edit()
        }else{
            if(this.info.hrScore == null){
                this.$notification['warning']({
                        message: '人事绩效系统中得分不能为空！'
                });
                this.confirmLoading = false;
                return;
            }
            this.add()
        }
        this.fetch()
        this.visible = false;    
    },
    handleCancel(e) {
        this.visible = false;
        this.fetch()
    },
    confirm(){
        confirm(this.assessId).then(res=>{
            if(res.data.success){
                this.$notification['success']({
                    message: '成功',
                    description:'确认成功！',
                });
                this.$router.go(-1)
            }else{
                this.$notification['error']({
                    message: '失败',
                    description:res.data.errorMessage,
                });
            }
        })
    },
    fetch(){
        info(this.assessId).then(res=>{
            this.year = res.data.year+'年1月1日  —  '+res.data.year+'年12月31日'
            this.teacherName = res.data.teacherName;
            this.technicalTitleName = res.data.technicalTitleName;
            this.result = res.data.detailList;
            this.data = this.result;
            this.totalScore = res.data.totalScore
            this.orgName=res.data.orgName
            this.confirmer=res.data.confirmer
            this.confirmDate=res.data.confirmDate
            this.hrScore=res.data.hrScore
            this.totalScore=res.data.totalScore
            this.approveInfo.approvalComments=res.data.approvalComments
            let temp = '';
            let subTemp = '';
            var rows = {start:0,end:0}
            var subRows = {start:0,end:0}
            for(var i = 0;i<this.data.length;i++){
                if(temp == ''){
                    temp = this.data[i].mainTitleCode;
                    if(i != 0){
                        rows.end = rows.end + 1;
                    }
                }else if(temp == this.data[i].mainTitleCode){
                    rows.end = rows.end + 1;
                }else{
                    this.rowSpan.push(rows);
                    let end = rows.end;
                    rows = {start:0,end:0}
                    rows.start = end+1;
                    rows.end = end+1;
                    temp = this.data[i].mainTitleCode;
                    if(i == this.data.length-1){
                        this.rowSpan.push(rows);
                    }
                }

                if(subTemp == ''){
                    subTemp = this.data[i].subTitleCode;
                    if(i != 0){
                        subRows.end = subRows.end + 1;
                    }
                }else if(subTemp == this.data[i].subTitleCode){
                    subRows.end = subRows.end + 1;
                }else{
                    this.subRowSpan.push(subRows);
                    let end = subRows.end;
                    subRows = {start:0,end:0}
                    subRows.start = end+1;
                    subRows.end = end+1;
                    subTemp = this.data[i].subTitleCode;
                    if(i == this.data.length-1){
                        this.subRowSpan.push(subRows);
                    }
                }
            }
            this.data.push({mainTitleName:'合计',hrScore:this.hrScore,approveScore:this.totalScore,colSpan:3})
    })
    }
    }
};
</script>
<style scoped>

.title{
    font-weight:bold;
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: 1rem;
}

.schoolYear{
    margin-bottom: 1rem;
    text-align: center;
}

.qr{
    font-weight:bold;
    margin-left: 1rem;
    margin-top: 1rem;
}

.bz{
    margin-left: 1rem;
    margin-top: 1rem;
    font-size: 0.9rem;
}

.qr-button{
    text-align: center;
    margin-top: 1rem;
}

    .btn-box{
        text-align: center;
        margin-top: 1rem;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }

    .operate{
        display:inline-block;
    }
    .info-main{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    .info-main .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1rem;
        position: relative;
    }
    .info-main .input-box p{
        width: 15rem;
        text-align: right;
    }
    .info-main .input-box .input{
        /* width: calc(100% - 0rem); */
        width: 30rem;
    }

</style>